import { handleStatus500 } from 'api/Utility/HandleStatus500'
import AxiosInitializer from 'api/Utility/AxiosInitializer'
import getToken from 'lib/authentication/GetToken'

export const fetchParticipantTags = async (userId: string) => {
  const axios = AxiosInitializer({ token: getToken() })

  const URL = `/users/${userId}/tags`
  try {
    const response = await axios.get(URL)

    return { tags: response.data.data }
  } catch (error: any) {
    return handleStatus500(error)
  }
}

export const addTag = async (userId: string, name: string) => {
  const axios = AxiosInitializer({ token: getToken() })

  const URL = `/users/${userId}/tags`

  try {
    const payload = {
      data: {
        attributes: {
          tag: {
            name,
          },
        },
      },
    }

    const response = await axios.post(URL, payload)

    return response
  } catch (error: any) {
    if (error.code == 'ERR_BAD_REQUEST') {
      const response = {
        status: error.response.status,
      }

      return response
    }

    return handleStatus500(error)
  }
}

export const deleteParticipantTag = async ({
  userId,
  name,
}: {
  userId: string
  name: string
}) => {
  const axios = AxiosInitializer({ token: getToken() })

  const URL = `/users/${userId}/tags/delete`

  try {
    const payload = {
      data: {
        attributes: {
          tag: {
            name,
          },
        },
      },
    }

    const response = await axios.post(URL, payload)

    return response
  } catch (error: any) {
    if (error.code == 'ERR_BAD_REQUEST') {
      const response = {
        status: error.response?.status,
      }

      return response
    }

    return handleStatus500(error)
  }
}
